<template>
    <div style="display: flex; margin: 10px;" >
        <select v-model="portionType" @change="onChange">
            <option value="P100">{{ STANDARDPORTION }}</option>
            <option value="PSTA">{{portiondes}} {{portion}} g</option>
            <option value="PPER">{{ PORTIONSELF }}</option>
        </select>
        <div v-if="portionType == 'PPER'" style="margin-left: 5px;">
            <input type="number" v-model="portionValue"/>
            <button @click="changeValue" style="margin-left: 5px;">{{RECALCULATE}}</button>
        </div>
    </div>    
</template>

<script>
import { getSTRING } from '@/js/utils';
export default {
    name: "FoodPortion",
    emits: { selectPortion : null},
    props: [ "lang" , "portion" , "portiondes" ],
    data() {
        return {
            portionType: "P100",
            portionValue: this.portion,
            RECALCULATE: '',
            PORTIONSELF: '',
            STANDARDPORTION: '100 g'
        }
    },
    mounted() {   
        this.RECALCULATE = getSTRING(this.lang, "RECALCULATE" , "Ricalcola");
        this.PORTIONSELF = getSTRING(this.lang , "PORTIONSELF" , "Porzione personalizzata");     
    },
    methods: {        
        onChange(){            
            if (this.portionType!="PPER") {
                if (this.portionType=="P100"){
                    this.portionValue = 100
                } else  if (this.portionType=="PSTA"){
                    this.portionValue = this.portion;
                }
                this.$emit("selectPortion", this.portionValue);
            }
    
        },
        changeValue() {
            this.$emit("selectPortion", this.portionValue);
        }
    }
}
</script>

<style></style>
